import type { TopFolderZipState } from "features/topFolderZipSlice";

export const TOP_FOLDER_ZIP_STORAGE_KEY = "calibrate_top_folder_zip_v2";

type PersistedV1 = {
  v: 2;
  userId: number;
  jobs: TopFolderZipState["jobs"];
  ready: TopFolderZipState["ready"];
};

export function persistTopFolderZipState(
  userId: number | undefined,
  slice: TopFolderZipState,
): void {
  if (userId == null) return;
  try {
    const payload: PersistedV1 = {
      v: 2,
      userId: Number(userId),
      jobs: slice.jobs,
      ready: slice.ready,
    };
    localStorage.setItem(TOP_FOLDER_ZIP_STORAGE_KEY, JSON.stringify(payload));
  } catch {
  }
}

export function loadTopFolderZipState(): Omit<PersistedV1, "v"> | null {
  try {
    const raw = localStorage.getItem(TOP_FOLDER_ZIP_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PersistedV1;
    if (parsed?.v !== 2 || parsed.userId == null) return null;
    return {
      userId: Number(parsed.userId),
      jobs: parsed.jobs ?? {},
      ready: parsed.ready ?? {},
    };
  } catch {
    return null;
  }
}

export function clearTopFolderZipStorage(): void {
  try {
    localStorage.removeItem(TOP_FOLDER_ZIP_STORAGE_KEY);
  } catch {
  }
}
